import { PolicyTermType } from '../../types/index';
import { updatePolicyTerm } from "actions/Utilities/Policy";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useUpdatePolicyTerm = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, data } = useMutation(
    (feeLevelNewData: PolicyTermType) => updatePolicyTerm(feeLevelNewData)
  );
  if (data) {
    if (data.status !== 200) {
      toast.fire("Failed", "Failed to Update Term", "error");
    } else {
      queryClient.invalidateQueries(["GetTerms"]);
      toast.fire("Success", "Term Updated Successfully", "success");
    }
  }
 
  return mutateAsync;
};
export default useUpdatePolicyTerm;
